.visManager {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  scrollbar-width: thin;
}

.visBar {
  flex: none;
  display: flex;
  height: var(--toolbar-height);
  background-color: var(--secondary-light-bg);
}

.visArea {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template:
    'dimMapper bar' auto
    'dimMapper vis' 1fr
    / min-content 1fr;
}

.fallback {
  composes: fallback from '../utils.module.css';
}

.fallback > p:first-child {
  margin: 0;
}

.fallbackHint {
  margin: 0.75em 0 0;
  font-style: italic;
  font-size: 90%;
}

.dimMapper {
  grid-area: dimMapper;
}

.vis {
  grid-area: vis;
}
